import * as React from "react";
import v from "@/module/Utils/variable";

interface pathInterface {
  pc: any;
  sp: any;
}

interface PictureProps {
  path: string | pathInterface;
  alt?: string;
}

const Picture: React.FC<PictureProps> = (props) => {
  const getImageOrPicture = () => {
    if (typeof props.path === "string") {
      return <img src={props.path} alt={props.alt} />;
    } else if (typeof props.path === "object") {
      return (
        <picture>
          <source
            srcSet={props.path.sp}
            media={`max-width: ${v.spWidth + 1}px`}
          />
          <img src={props.path.pc} alt={props.alt} />
        </picture>
      );
    }
  };

  return <>{getImageOrPicture()}</>;
};

Picture.defaultProps = {
  alt: "",
};

export default Picture;
